// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { DefaultVisualization as View } from 'ui-components'
import { Aggregate } from '~map-settings/App/General/DefaultVisulization/Aggregate'
import { Category } from '~map-settings/App/General/DefaultVisulization/Category'
import { HexagonAggregate } from '~map-settings/App/General/DefaultVisulization/HexagonAggregate'
import { useGetDefaultVisualizationOptions } from '~map-settings/hooks/useGetDefaultVisualizationOptions'
import { useUpdateDefaultVisualization } from '~map-settings/hooks/useUpdateDefaultVisualization'

const SecondaryInput = {
  marker: null,
  heatmap: null,
  category: <Category />,
  aggregate: <Aggregate />,
  hexagon: <HexagonAggregate />
}

export const DefaultVisualization = () => {
  const { options, selected } = useGetDefaultVisualizationOptions()
  const { update } = useUpdateDefaultVisualization()

  const handleChange = async (event) => {
    const result = options.find((item) => item.id === event.target.value)
    if (result) {
      const { Icon, label, ...tmp } = result
      await update(tmp)
    }
  }

  return (
    <View
      value={selected?.id}
      options={options}
      onChange={handleChange}
      slots={{
        input: selected ? SecondaryInput[selected.type] : null
      }}
    />
  )
}
